import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppInitializationService } from '../services/app-initialization.service';

export const appInitializationGuard: CanActivateFn = async () => {
  const initService = inject(AppInitializationService);
  await initService.ensureInitialized();
  return true;
};
